const RETRY_LAZY_REFRESH_KEY = 'retry-lazy-refreshed-count';
const MAX_REFRESH_COUNT = 3;
const getRefreshCount = () => Number(JSON.parse(window.sessionStorage.getItem(RETRY_LAZY_REFRESH_KEY) || '0'));
const incrementRefreshCount = (refreshCount) => {
    const newRefreshCount = refreshCount + 1;
    window.sessionStorage.setItem(RETRY_LAZY_REFRESH_KEY, String(newRefreshCount));
};
window.addEventListener('error', (e) => {
    if (/Loading chunk [\d]+ failed/.test(e.message)) {
        const refreshCount = getRefreshCount();
        if (refreshCount < MAX_REFRESH_COUNT) {
            incrementRefreshCount(refreshCount);
            window.location.reload();
        }
    }
});
export {};
